import React from 'react';
import './FnSpresskit.css';

import Navbar from '../../../components/navbar/Navbar';
import Footer from '../../../components/footer/Footer';

import FnSpressKitGallery from './FnSpressKitGallery';
import FnSpressKitLogos from './FnSpressKitLogos';

import FnS_logo from '../../../assets/images/FnS_logo.png';

import FnSpress_header from '../../../assets/images/banner-FnSpress.webp';
import FnSpress_header_safari from '../../../assets/images/banner-FnSpress.png';

import news_1 from '../../../assets/images/FnSPressKit/news/news-safc-feb-23.webp'
import news_1_safari from '../../../assets/images/FnSPressKit/news/news-safc-feb-23.png'
import news_2 from '../../../assets/images/FnSPressKit/news/news-kotaku-feb-23.webp'
import news_2_safari from '../../../assets/images/FnSPressKit/news/news-kotaku-feb-23.png'
import news_3 from '../../../assets/images/FnSPressKit/news/Paper-Cactus-Gamescom-2023.webp'
import news_3_safari from '../../../assets/images/FnSPressKit/news/Paper-Cactus-Gamescom-2023.jpg'

const FnSpresskit = () => {
  return ( 
    <div className='presskit-container'>
        <Navbar />
        <div className='presskit-content'>
          <div className='page-header'>
            <div className='page-header-title'>
                <div className='page-divider'></div>
                <h1>Fox and Shadow</h1>
                <p className='subtitle'>Press Kit</p>
            </div>
            <picture>
                <source srcSet={FnSpress_header} type='image/webp'/>
                <source srcSet={FnSpress_header_safari} type='image/png'/>
                <img className="page-header-image" src={FnSpress_header} alt="Fox and Shadow Press Kit"/>
            </picture>
          </div>

          <div className='presskit-main'>
            <div className='side-navbar'>
                <div className='side-navbar-nav'>
                    <div className='page-divider'></div>
                    <a href='#information'><p>Information</p></a>
                    <a href='#images'><p>Game Images and Concept Art</p></a>
                    <a href='#videos'><p>Videos</p></a>
                    <a href='#logosandicons'><p>Logos and Icons</p></a>
                    <a href='#news'><p>News Appearances</p></a>
                    <a href='#contact'><p>Contact Team</p></a>
                </div>
            </div>

            <div className='presskit-sections'>
                <section id='information'>
                    <div className='section-header'>
                        <div className='page-divider'></div>
                        <h1>Information</h1>
                    </div>
                    <div className='information-container'>
                        <div className="information-left">
                            <img className='information-logo' src={FnS_logo} alt="Fox and Shadow Logo" />
                            <h2>GENRE</h2>
                            <p>Deck-building Roguelike</p>
                        </div>
                        <div className='information-right'>
                            <h2>PLANNED PLATFORMS</h2>
                            <p>PC</p>
                            <h2>ESTIMATED COMPLETION DATE</h2>
                            <p> End of Q2 2025 Early Access</p>
                            <h2>SYNOPSIS</h2>
                            <p>
                            In this dual-deckbuilding roguelike, you'll need to balance moves from both your pilot and their drone to fight your way through a broken city, where rogue AI rules the streets.</p>
                            <p>While your fellow humans rest in stasis underground, only a savvy few are trusted to scrap, scavenge, and trade for the resources above-- anything it takes to keep the lights on.</p>
                            <p>Are you worth the air you breathe?</p>
                        </div>
                    </div>
                </section>

                <section id='images'>
                    <div className='section-header'>
                        <div className='page-divider'></div>
                        <h1>Game Images and Concept Art</h1>
                    </div>
                    <div className='gallery-container'>
                        <FnSpressKitGallery/>
                    </div>
                </section>

                <section id='videos'>
                    <div className='section-header'>
                        <div className='page-divider'></div>
                        <h1>Videos</h1>
                    </div>
                    <div className='videos-container'>
                        <div className="video-grid">
                            <div className="video-item">
                                <div className="video-wrapper">
                                    <iframe
                                        width="560"
                                        height="315"
                                        src="https://www.youtube.com/embed/SYOPmbZnp10"
                                        title="Fox and Shadow Gameplay Trailer"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                    ></iframe>
                                </div>
                                <h3>Fox and Shadow Gameplay Trailer</h3>
                            </div>
                            <div className="video-item">
                                <div className="video-wrapper">
                                    <iframe
                                        width="560"
                                        height="315"
                                        src="https://www.youtube.com/embed/KsBgk6alRQU"
                                        title="Fox and Shadow Demo Showcase"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                    ></iframe>
                                </div>
                                <h3>Fox and Shadow Demo Showcase</h3>
                            </div>
                        </div>
                    </div>
                </section>

                <section id='logosandicons'>
                    <div className='section-header'>
                        <div className='page-divider'></div>
                        <h1>Logos and Icons</h1>
                    </div>
                    <div className='gallery-container'>
                        <FnSpressKitLogos/>
                    </div>
                </section>

                <section id='news'>
                    <div className='section-header'>
                        <div className='page-divider'></div>
                        <h1>News Appearances</h1>
                    </div>
                    <div className='news-container'>
                        <div className='news-card'>
                            <picture>
                                <source srcSet={news_1} type='image/webp'/>
                                <source srcSet={news_1_safari} type='image/png'/>
                                <img src={news_1_safari} alt="SAFC News" className="news-image"/>
                            </picture>
                            <div className='news-content'> 
                                <a href="https://www.safilm.com.au/latest-news/hundreds-turn-out-to-the-safcs-inaugural-sage-sa-game-exhibition/">
                                    <span>Hundreds turn out to the SAFC's inaugural SAGE: SA Game Exhibition</span>
                                </a>
                                <span className="news-source">South Australian Film Corporation</span>
                            </div>
                        </div>

                        <div className='news-card'>
                            <picture>
                                <source srcSet={news_2} type='image/webp'/>
                                <source srcSet={news_2_safari} type='image/png'/>
                                <img src={news_2_safari} alt="Kotaku News" className="news-image"/>
                            </picture>
                            <div className='news-content'> 
                                <a href="https://www.kotaku.com.au/2023/02/south-australia-is-ready-to-be-our-next-major-games-development-hub/">
                                    <span>South Australia Is Ready To Be Our Next Major Games Development Hub</span>
                                </a>
                                <span className="news-source">Kotaku Australia</span>
                            </div>
                        </div>

                        <div className='news-card'>
                            <picture>
                                <source srcSet={news_3} type='image/webp'/>
                                <source srcSet={news_3_safari} type='image/png'/>
                                <img src={news_3_safari} alt="Glam Adelaide News" className="news-image"/>
                            </picture>
                            <div className='news-content'> 
                                <a href="https://glamadelaide.com.au/south-australian-studios-level-up-for-worlds-largest-gaming-event/">
                                    <span>South Australian studios level up for world's largest gaming event</span>
                                </a>
                                <span className="news-source">Glam Adelaide</span>
                            </div>
                        </div>
                    </div>
                </section>

                <section id='contact'>
                    <div className='section-header'>
                        <div className='page-divider'></div>
                        <h1>Contact Team</h1>
                    </div>
                    <div className='contact-container'>
                        <div className='team-members'>
                            <div className="team-member">
                                <p className="member-name">Leo "BlueTwosdays" Cheung</p>
                                <p className="member-role">Director/Lead Artist</p>
                            </div>
                            <div className="team-member">
                                <p className="member-name">Jackson Michael</p>
                                <p className="member-role">Lead Programmer</p>
                            </div>
                            <div className="team-member">
                                <p className="member-name">Sapphire Van Veen</p>
                                <p className="member-role">Lead Designer</p>
                            </div>
                            <div className="team-member">
                                <p className="member-name">Chris "Osmenn" Hill</p>
                                <p className="member-role">Environmental Artist</p>
                            </div>
                            <div className="team-member">
                                <p className="member-name">John Oestmann</p>
                                <p className="member-role">Composer</p>
                            </div>
                        </div>
                        <div className='contact-info'>
                            <div className="contact-item">
                                <p className="contact-label">Inquiries</p>
                                <a href="mailto:contact@papercactusgames.com">contact@papercactusgames.com</a>
                            </div>
                            <div className="contact-item">
                                <p className="contact-label">X</p>
                                <a href="https://x.com/PapercactusGame">https://x.com/PapercactusGame</a>
                            </div>
                            <div className="contact-item">
                                <p className="contact-label">Discord</p>
                                <a href="https://discord.gg/7szET4A">https://discord.gg/7szET4A</a>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
          </div>
        </div>
        <Footer/>
    </div>
  )
}

export default FnSpresskit;